import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';

import { getCurrencySymbol } from 'helpers/financial';

import ItemBasicPrice from 'components/layout/item/ItemBasicPrice';
import ItemStock from 'components/layout/item/ItemStock';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormInput from 'components/forms/FormInput';

class VariantStockAndPrices extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['pricing'];
  }

  render() {
    const {
      webApp,
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      user,
      inModal,
    } = this.props;

    const currencySymbol = getCurrencySymbol(entity.getPricing().getCurrency());

    return (
      <div class="clearfix">
        {entityLoaded ? (
          <Row>
            <Col xs={12} md={inModal ? 12 : 4}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.sales_price}</p>
                  <div class="form-group-attached">
                    <FormAutocomplete
                      label={user.financial.vat_name}
                      name="vatRate"
                      value={entity.getPricing().getVatRate()}
                      meta={entity.getPricing().getVatRateMetaInformation()}
                      validation={entity.getPricing().getVatRateValidationResult()}
                      onChange={this.updateEntity}
                      options={
                        user &&
                        user.financial &&
                        user.financial.vat_rates &&
                        user.financial.vat_rates &&
                        user.financial.vat_rates.map(vatRate => {
                          return { value: vatRate, label: vatRate + '%' };
                        })
                      }
                      complete
                      disabled={disabled}
                    />
                    <FormInput
                      prefixAddon={currencySymbol}
                      type="number"
                      label={messages.price}
                      name="price"
                      value={entity.getPricing().getPrice()}
                      meta={entity.getPricing().getPriceMetaInformation()}
                      validation={entity.getPricing().getPriceValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      prefixAddon={currencySymbol}
                      type="number"
                      label={messages.pseudo_price}
                      name="pseudoPrice"
                      value={entity.getPricing().getPseudoPrice()}
                      meta={entity.getPricing().getPseudoPriceMetaInformation()}
                      validation={entity.getPricing().getPseudoPriceValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      prefixAddon={currencySymbol}
                      type="number"
                      label={messages.express_price}
                      name="expressPrice"
                      value={entity.getPricing().getExpressPrice()}
                      meta={entity.getPricing().getExpressPriceMetaInformation()}
                      validation={entity.getPricing().getExpressPriceValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      prefixAddon={currencySymbol}
                      type="number"
                      label={messages.overnight_price}
                      name="overnightPrice"
                      value={entity.getPricing().getOvernightPrice()}
                      meta={entity.getPricing().getOvernightPriceMetaInformation()}
                      validation={entity.getPricing().getOvernightPriceValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormInput
                      prefixAddon={currencySymbol}
                      type="number"
                      label={messages.sameday_price}
                      name="samedayPrice"
                      value={entity.getPricing().getSamedayPrice()}
                      meta={entity.getPricing().getSamedayPriceMetaInformation()}
                      validation={entity.getPricing().getSamedayPriceValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                  </div>
                  {/*<p class="m-t-10">{messages.basic_price}</p>
                  <ItemBasicPrice
                    itemEntity={this.props.itemEntity}
                    type="variant"
                    entity={entity}
                    entityLoaded={entityLoaded}
                    changeEntity={this.props.changeEntity}
                    disabled={disabled}
                    inModal={inModal}
                  />*/}
                </div>
              </div>
            </Col>
            {/*
            <ItemStock
              entityLoaded={entityLoaded}
              entity={entity}
              changeEntity={this.props.changeEntity}
              disabled={disabled}
            />*/}
          </Row>
        ) : null}
      </div>
    );
  }
}
VariantStockAndPrices.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    webApp: state.webApp,
    user: state.login.user,
  };
};

export default injectIntl(connect(mapStateToProps)(VariantStockAndPrices));
